<template>
  <div @click="link" :class="vClass">
    <h3 class="subheading font-weight-bold">{{ title }}</h3>
    <div class="text-body-1">
      <slot name="content">{{ details }}</slot>
    </div>
    <div class="text-right" v-if="actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VNotification',
  props: {
    link: { type: Function, default: () => {} },
    title: { type: String, default: '' },
    details: { type: String, default: '' },
    actions: { type: Boolean, default: false },
    info: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    warning: { type: Boolean, default: false },
    success: { type: Boolean, default: false }
  },
  computed: {
    vClass() {
      return {
        'v-notif': true,
        'pa-2': true,
        info: this.info,
        error: this.error,
        warning: this.warning,
        success: this.success,
        neutral: !this.info && !this.success && !this.error && !this.warning,
        link: !!this.link,
        actions: this.actions
      }
    }
  }
}
</script>

<style scoped lang="scss">
.v-notif {
  background-color: #f8f8f8 !important;
  color: var(--v-grey-lighten0);
  border-left-width: 3px;
  border-left-style: solid;
  border-left-color: var(--v-grey-lighten0);
}

.v-notif:hover {
  background-color: var(--v-grey-lighten3) !important;
}

.v-notif.actions {
  padding-bottom: 0;
}

.v-notif.link {
  cursor: pointer;
}
</style>
